import { useEffect, lazy } from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from '../pages/home'
import PcHome from '../pages/pcHome'
import Entry from '../pages/entry'
import Login from '../pages/login'
import { Suspense } from 'react';

const Preview3D = lazy(() => import('../pages/preview3D'));
// const OrderList = lazy(() => import('../pages/order_list'));


const Index: React.FunctionComponent = () => {


    return (
        <div>
            <BrowserRouter>
                <Suspense fallback={<div>{t('加载中')}...</div>}>
                    <Routes>
                        <Route path="/cloth/h5" element={<Login />} />
                        <Route path="/cloth/h5/entry/:token" element={<Entry />} />
                        <Route path="/cloth/h5/design/:id" element={<Home />} />
                        {/* <Route path="/cloth/h5/order/list" element={<OrderList />} /> */}
                        {/* 接收路径https://jxfdiy.oss-cn-hongkong.aliyuncs.com/files/aabfc202512021143014543.json */}
                        {/* <Route path="/cloth/h5/preview/:directory/:name" element={<Preview3D />} /> */}
                        {/* 接收路径http://jxfdiy.zw.com/cloth/h5/preview/files/2025/12/04/file_1764820068323.json */}

                        <Route path="/cloth/h5/preview/:directory/:year/:month/:day/:name" element={<Preview3D />} />

                        <Route path="/cloth/pc/entry/:token" element={<Entry />} />
                        <Route path="/cloth/pc/design/:id" element={<PcHome />} />
                        <Route path="/fonts/*" element={null} />
                    </Routes>
                </Suspense>
            </BrowserRouter>
        </div>
    )
}

export default Index
